import { NgModule } from '@angular/core';
import { StopClickPropagationDirective } from './stop-click-propagation.directive';

@NgModule({
  declarations: [StopClickPropagationDirective],
  imports: [],
  exports: [StopClickPropagationDirective]
})
export class StopClickPropagationModule{}
